import * as React from "react"
const SvgCart = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 22.428q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 20.428q0-.825.588-1.412A1.93 1.93 0 0 1 7 18.429q.824 0 1.412.587.588.588.588 1.413c0 .825-.196 1.02-.588 1.412A1.93 1.93 0 0 1 7 22.428m10 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 15 20.428q0-.825.588-1.412A1.93 1.93 0 0 1 17 18.429q.824 0 1.413.587.587.588.587 1.413c0 .825-.196 1.02-.587 1.412a1.93 1.93 0 0 1-1.413.587m-10.85-16 2.4 5h7l2.75-5zm-.95-2h14.75q.575 0 .875.513t.025 1.038l-3.55 6.4q-.275.5-.738.774a1.94 1.94 0 0 1-1.012.275H8.1l-1.1 2h11q.424 0 .712.288t.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288H7q-1.125 0-1.7-.988-.575-.987-.05-1.962l1.35-2.45-3.6-7.6H2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 1 3.429q0-.425.288-.713A.97.97 0 0 1 2 2.429h1.625q.274 0 .525.15.25.15.375.425L5.2 4.429Z" />
  </svg>
)
export default SvgCart
